import React, { useMemo } from 'react';
import { ListItem, ListItemType } from '@common-fe/common-fe';

import {
  DownloadStatementButton,
  ViewStatementButton,
} from '@/modules/transaction/components/Statements/components/StatementsList/components';
import { Statement } from '@/modules/transaction/components/Statements/statements.types';

interface Props {
  statements?: Statement[];
}

const useStatementsList = ({ statements }: Props) => {
  const formattedFields = useMemo(() => {
    if (!statements?.length) return [];

    const formatted: ListItem[] = statements.map((statement: Statement) => ({
      id: statement?.id || '',
      dropAlign: { bottom: 'top', right: 'right' },
      rowStyle: {
        minHeight: 76,
      },
      fields: [
        {
          key: 'statementName',
          title: statement.name || 'Statement name',
          type: ListItemType.Node,
          node: <ViewStatementButton name={statement.name} id={statement.id} url={statement.url} />,
          flex: 1,
        },
        {
          key: 'downloadStatement',
          title: statement?.id,
          type: ListItemType.Node,
          node: (
            <DownloadStatementButton
              id={statement.documentId || statement.id}
              fileName={statement.name}
              url={statement.url}
            />
          ),
          flex: 1,
        },
      ],
    }));

    return formatted;
  }, [statements]);

  return {
    fields: formattedFields,
  };
};

export default useStatementsList;
